import { Component, Input, Output, EventEmitter } from '@angular/core';

interface ImageLoadEvent {
  url: string;
  loadTime: number;
}

interface ImageErrorEvent {
  url: string;
  error: string;
}

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent{

  @Input() click!: (...args: any[]) => any;
  @Input() index!: any; // Index do item na lista
  @Input() image: string = ""; // URL da imagem
  @Input() customStyle?: { [key: string]: string };
  @Input() fallback: string = "assets/imgs/no-picture.png"; // Imagem de fallback
  @Input() loadingSpinner: string = "assets/imgs/loading-spinner.gif"; // Spinner de loading
  
  // Configurações avançadas de lazy loading
  @Input() enablePreload: boolean = true;
  @Input() enableCompression: boolean = true;
  @Input() compressionQuality: number = 0.8;
  @Input() aspectRatio: string = "1:1";
  @Input() rootMargin: string = "100px";
  @Input() threshold: number = 0.1;
  @Input() enableWebP: boolean = true;
  @Input() showProgress: boolean = false;
  @Input() borderRadius: string = "8%";
  @Input() width: string = "100%";

  @Output() imageLoadedEvent = new EventEmitter<ImageLoadEvent>();
  @Output() imageErrorEvent = new EventEmitter<ImageErrorEvent>();

  imageLoaded: boolean = false; // Estado de carregamento da imagem

  constructor(){}

  onImageLoad(event: any): void {
    this.imageLoaded = true;
    const loadTime = performance.now();
    this.imageLoadedEvent.emit({ url: this.image, loadTime });
  }

  onImageError(event: any): void {
    this.imageLoaded = true;
    this.imageErrorEvent.emit({ url: this.image, error: 'Image failed to load' });
  }

  handleClick(): void {
    if (this.click) {
      this.click(this.index); // Chama a função se ela foi fornecida
    }
  }
}